import { SelectContent, SelectItem } from '@readcloud/ui';
import * as React from 'react';
import {
  Select as SelectUI,
  SelectTrigger,
  SelectValue,
} from '@readcloud/ui/select';
export interface ISelectProps extends Partial<HTMLInputElement> {
  options: { label: string; value: string | number }[];
  onSelect: (option: { label: string; value: string | number }) => void;
  matchWidth?: boolean;
  variant?: string;
  placement?: 'top' | 'bottom';
  defaultValue?: string;
  placeholder?: string;
  fullWidth?: boolean;
}

export const Select: React.FunctionComponent<ISelectProps> = ({
  options,
  ...props
}) => {
  const targetRef = React.useRef<HTMLButtonElement>();
  const onSelect = (option: { label: string; value: string | number }) => {
    props.onSelect(option);
  };

  const [show, setShow] = React.useState(false);
  const handleToggle = () => {
    setShow((prev) => !prev);
  };

  const [selected, setSelected] = React.useState<{
    label: string;
    value: string | number;
  }>();

  React.useEffect(() => {
    if (!props.value) return;

    const tempSel = options.find(
      (option) => option.value.toString() === props.value.toString()
    );
    setSelected(tempSel);
  }, [props.value]);

  React.useEffect(() => {
    if (!!props.value || !props.defaultValue) return;

    const tempSel = options.find(
      (option) => option.value.toString() === props.defaultValue.toString()
    );
    setSelected(tempSel);
  }, [props.defaultValue, !!props.value]);

  return (
    <div className='select__content-component'>
      <SelectUI
        onValueChange={(value) =>
          onSelect(options.find((option) => option.value.toString() === value))
        }
        defaultValue={
          props.value ?? props.defaultValue ?? options[0].value.toString()
        }
        
      >
        <SelectTrigger className="rc-w-max-[180px]">
          <SelectValue placeholder={props.placeholder} />
        </SelectTrigger>
        <SelectContent className='select__content-component'>
          {options.map((option) => (
            <SelectItem value={option.value.toString()}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </SelectUI>
    </div>
  );
};
